import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MarketEntryDataModel } from 'src/Models/PriceCalculationModel';
import { AppConfig } from 'src/Services/app.config';
import { PricingQuotesService } from 'src/Services/pricing-quotes.service';
import { CheckAuth } from 'src/Services/utility.service';
import { checkStepIsCompletedVendor, getIncompletedStepVendor } from 'src/app/Shared/commonMethods';
import { Globle } from 'src/app/Shared/global';
import { SessionStorageService } from 'src/common/session-storage.service';

interface MarketEntrySection {
  providerId: number;
  provider: string;
  expanded: boolean;
  rows: MarketEntryDataModel[];
  sosServiceFees: number;
  sosCorpFeelingFees: number;
  sosLLCFeelingFees: number;
  registeredAgentFees: number;
  pucServiceFees: number;
  pscFeelingFees: number;
  localCounselFees: number;
  inteserraTotal: number;
  dbaFillinfFees: number;
  dbaServiceFees: number;
  dbA_RA_Fees: number;
  bond: number;
  puC_Filing_Fees: number;
  soS_Service_Fees_SelectedAll: boolean;
  dbA_Service_Fees_SelectedAll: boolean;
  soS_Corp_Filling_Fees_SelectedAll: boolean;
  soS_LLC_Filing_Fees_SelectedAll: boolean;
  dbA_Filing_Fees_SelectedAll: boolean;
  registered_Agent_Fees_SelectedAll: boolean;
  puC_Service_Fees_SelectedAll: boolean;
  puC_Filing_Fees_SelectedAll: boolean;
  psC_FilingsAndPublication_Fees_SelectedAll: boolean;
  local_Counsel_Fees_SelectedAll: boolean;
  registered_Agent_DBA_Fees_SelectedAll: boolean;
  bond_SelectedAll: boolean;
  soS_Service_Fees_NAisSelected: boolean;
  dbA_Service_Fees_NAisSelected: boolean;
  soS_Corp_Filling_Fees_NAisSelected: boolean;
  soS_LLC_Filing_Fees_NAisSelected: boolean;
  dbA_Filing_Fees_NAisSelected: boolean;
  registered_Agent_Fees_NAisSelected: boolean;
  puC_Service_Fees_NAisSelected: boolean;
  psC_FilingsAndPublication_Fees_NAisSelected: boolean;
  local_Counsel_Fees_NAisSelected: boolean;
  registered_Agent_DBA_Fees_NAisSelected: boolean;
  bond_NAisSelected: boolean;
  puC_Filing_Fees_NAisSelected: boolean;
}

const MARKET_ENTRY_PROVIDER_LABELS: { [key: number]: string } = {
  1: 'CLEC',
  2: 'IXC',
  3: 'Voip',
  4: 'Wireless'
};

@Component({
  selector: 'app-client-quote-notes',
  templateUrl: './client-quote-notes.component.html',
  styleUrls: ['./client-quote-notes.component.css']
})
export class ClientQuoteNotesComponent implements OnInit {
  userID: any;
  appModel: any;
  SelectedTool: string;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  tokenKey: any;

  mainUrl: string;
  subUrl: string;

  priceQuoteId: number = 0;
  isSubmit: boolean = false;
  isEdit: boolean = false;
  currentActiveTab: number = 1;
  notes: string;
  clientInformationId: number = 0;

  clientCompanyId: string;
  clientcompanyName: string;

  listofMarketEntryData: MarketEntryDataModel[];
  listofMarketEntryOldData: any;
  listofMarketEntryData1: MarketEntryDataModel;
  listofMarketEntryData2: MarketEntryDataModel;

  sosServiceFees?: number = 0.00;
  sosCorpFeelingFees?: number = 0.00;
  sosLLCFeelingFees?: number = 0.00;
  registeredAgentFees?: number = 0.00;
  pucServiceFees?: number = 0.00;
  pscFeelingFees?: number = 0.00;
  localCounselFees?: number = 0.00;
  inteserraTotal?: number = 0.00;
  companyTotal?: number = 0.00;
  dbaFillinfFees?: number = 0.00;
  dbaComSpecFillingFees?: number = 0.00;
  Total?: number = 0.00;
  dbaServiceFees?: number = 0.00;
  dbaComSpecServiceFees?: number = 0.00;
  dbA_Inteserra_Fee?: number = 0.00;
  dbAFillingsFees?: number = 0.00;
  dbA_RA_Fees?: number = 0.00;
  bond?: number = 0.00;
  puC_Filing_Fees?: number = 0.00;

  soS_Service_Fees_SelectedAll: boolean = false;
  dbA_Service_Fees_SelectedAll: boolean = false;
  soS_Corp_Filling_Fees_SelectedAll: boolean = false;
  soS_LLC_Filing_Fees_SelectedAll: boolean = false;
  dbA_Filing_Fees_SelectedAll: boolean = false;
  registered_Agent_Fees_SelectedAll: boolean = false;
  puC_Service_Fees_SelectedAll: boolean = false;
  puC_Filing_Fees_SelectedAll: boolean = false;
  psC_FilingsAndPublication_Fees_SelectedAll: boolean = false;
  local_Counsel_Fees_SelectedAll: boolean = false;
  registered_Agent_DBA_Fees_SelectedAll: boolean = false;
  bond_SelectedAll: boolean = false;

  soS_Service_Fees_NAisSelected: boolean = false;
  dbA_Service_Fees_NAisSelected: boolean = false;
  soS_Corp_Filling_Fees_NAisSelected: boolean = false;
  soS_LLC_Filing_Fees_NAisSelected: boolean = false;
  dbA_Filing_Fees_NAisSelected: boolean = false;
  registered_Agent_Fees_NAisSelected: boolean = false;
  puC_Service_Fees_NAisSelected: boolean = false;
  psC_FilingsAndPublication_Fees_NAisSelected: boolean = false;
  local_Counsel_Fees_NAisSelected: boolean = false;
  registered_Agent_DBA_Fees_NAisSelected: boolean = false;
  bond_NAisSelected: boolean = false;
  puC_Filing_Fees_NAisSelected: boolean = false;
  isMarketEntry: boolean = false;
  marketEntryName: string;
  marketEntryProvider: number = 0;
  marketEntrySections: MarketEntrySection[] = [];
  previousTotal: number = 0;

  constructor(private readonly checkAuth: CheckAuth,
    private readonly activedRoute: ActivatedRoute,
    private readonly globle: Globle,
    private readonly router: Router,
    private readonly PricingQuotesMaster: PricingQuotesService,
    private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = sessionStorage.getItem('UserId');
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.clientCompanyId = sessionStorage.getItem('ClientCompanyId');
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.clientcompanyName = sessionStorage.getItem('ClientCompanyName');
    this.titleService.setTitle('Quote Request | JSi360');

    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.priceQuoteId = params['id'];
        }
      }
    });
    this.mainUrl = '/View/';
    if (this.priceQuoteId != null) {
      this.GetProgressStepDetailsById(this.priceQuoteId)
      this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
    }
    else {
      this.globle.cApp.statusModel.isCompanyProfileDetailsCompleted = null;
      this.globle.cApp.statusModel.isAddCompQueCompleted = null;
      this.globle.cApp.statusModel.isStateSelectionCompleted = null;
      this.globle.cApp.statusModel.isNotes = null;
      this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
    }
  }

  ngOnInit() {

    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.isEdit = true;
          this.GetComplianceByClientInformationId(this.priceQuoteId);
          this.GetClientInformationById(params['id']);
          this.GetMarketEntryDataById(this.priceQuoteId);
        }
      }
    });
  }

  GetClientInformationById(priceQuoteId: number) {
    this.blockDocument();

    this.PricingQuotesMaster.GetClientInformationById(this.tokenKey, priceQuoteId, 0, false).subscribe(
      result => {
        this.unblockDocument();
        if (result['status'] == 'Success') {
          this.notes = result['clientInformation'].notes;
          this.clientInformationId = result['clientInformation'].clientInformationId;
        }

        if (result['clientInformation'].marketEntryProvider == 1) {
          this.marketEntryName = " - CLEC";
        }
        else if (result['clientInformation'].marketEntryProvider == 2) {
          this.marketEntryName = " - IXC";
        }
        else if (result['clientInformation'].marketEntryProvider == 3) {
          this.marketEntryName = " - VoIP";
        }
        else if (result['clientInformation'].marketEntryProvider == 4) {
          this.marketEntryProvider = 4;
          this.marketEntryName = " - Wireless";
        }
      });
  }

  previousStep() {
    let navigation = '/View/client-quote-compliance/' + this.priceQuoteId;
    this.router.navigate([navigation]);
  }

  save(clientForm: any) {

    this.isSubmit = true;

    if (this.isMarketEntry) {
      this.blockDocument();

      for (let s = 0; s < this.marketEntrySections.length; s++) {
        const section = this.marketEntrySections[s];
        this.applySectionNaFlagsToRows(section);
        for (let iCounter = 0; iCounter < section.rows.length; iCounter++) {
          section.rows[iCounter].createdBy = this.userID;
        }
      }

      this.PricingQuotesMaster.GetMultipleMarketEntryData(this.tokenKey, this.priceQuoteId).subscribe(
        results => {
          if (results['status'] == 'Success') {

            this.listofMarketEntryOldData = results['compliance'];

            for (let iCounter = 0; iCounter < this.listofMarketEntryData.length; iCounter++) {
              const current = this.listofMarketEntryData[iCounter];
              const oldRow = this.findMatchingOldRow(current);

              if (oldRow) {
                if (current.soS_Service_Fees != oldRow.soS_Service_Fees)
                  current.soS_Service_Fees_Changed = true;

                if (current.dbA_Service_Fees != oldRow.dbA_Service_Fees)
                  current.dbA_Service_Fees_Changed = true;

                if (current.soS_Corp_Filling_Fees != oldRow.soS_Corp_Filling_Fees)
                  current.soS_Corp_Filling_Fees_Changed = true;

                if (current.soS_LLC_Filing_Fees != oldRow.soS_LLC_Filing_Fees)
                  current.soS_LLC_Filing_Fees_Changed = true;

                if (current.dbA_Filing_Fees != oldRow.dbA_Filing_Fees)
                  current.dbA_Filing_Fees_Changed = true;

                if (current.registered_Agent_Fees != oldRow.registered_Agent_Fees)
                  current.registered_Agent_Fees_Changed = true;

                if (current.dbA_RA_Fees != oldRow.dbA_RA_Fees)
                  current.registered_Agent_DBA_Fees_Changed = true;

                if (current.puC_Service_Fees != oldRow.puC_Service_Fees)
                  current.puC_Service_Fees_Changed = true;

                if (current.puC_Filing_Fees != oldRow.puC_Filing_Fees)
                  current.puC_Filing_Fees_Changed = true;

                if (current.psC_FilingsAndPublication_Fees != oldRow.psC_FilingsAndPublication_Fees)
                  current.publicationFees_Changed = true;

                if (current.local_Counsel_Fees != oldRow.local_Counsel_Fees)
                  current.local_Counsel_Fees_Changed = true;

                if (current.bond != oldRow.bond)
                  current.bond_Changed = true;
              }

              current.createdBy = this.userID;
            }

            let value = {
              listofMarketEntryData: this.listofMarketEntryData,
              priceQuoteId: this.priceQuoteId,
              IsProposalDetailsCompleted: true,
              isAdmin: false
            }

            this.PricingQuotesMaster.MarketEntryDataAddUpdate(this.tokenKey, value).subscribe(
              result => {
                this.unblockDocument();
                if (result['status'] == 'Success') {
                  this.globle.cApp.statusModel.isProposalDetailsCompleted = true;
                }
                else {
                  this.showMessage(result['status'], 'Error', 'error');
                }
              },
              error => {
                this.unblockDocument()
                this.showMessage(error, 'Error', 'error');
              }
            );
          }
        }
      )
    }

    let value = {
      clientInformationId: this.clientInformationId,
      priceQuoteId: this.priceQuoteId,
      notes: this.notes,
      createdBy: this.userID,
      IsVendor: true
    }

    this.blockDocument();
    this.PricingQuotesMaster.NotesAddUpdate(this.tokenKey, value).subscribe(
      result => {
        this.unblockDocument();
        if (result['status'] == 'Success') {
          sessionStorage.removeItem('ClientCompanyName');
          this.globle.cApp.statusModel.isAttechedDetailsCompleted = true;
          if (result['message'] != "") {
            this.showMessage(result['message'], 'Warning', 'warning')
          }
          else {
            this.showMessage('Quote Request saved successfully', 'success', 'success');
            this.router.navigate(['/View/client-quote-list']);
          }

          this.unblockDocument();
        }
        else {
          this.showMessage(result['status'], 'Error', 'error');
          this.unblockDocument();
        }
      },
      error => {
        this.unblockDocument();
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  private findMatchingOldRow(current: MarketEntryDataModel): any {
    if (!this.listofMarketEntryOldData || this.listofMarketEntryOldData.length === 0) {
      return null;
    }

    const matched = this.listofMarketEntryOldData.filter(function (x) {
      return x.marketEntryId == current.marketEntryId && x.stateId == current.stateId;
    });

    if (matched.length > 0) {
      return matched[0];
    }

    return null;
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  activeTab(url: string, tabId: number) {

    if (this.priceQuoteId != null) {
      if (checkStepIsCompletedVendor(url, this.globle.cApp.statusModel)) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + url + '/' + this.priceQuoteId;
        this.router.navigate([navigate]);
      }

      this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
      if (url == this.subUrl) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + this.subUrl + '/' + this.priceQuoteId;
        this.router.navigate([navigate]);
      }
    }
    else {
      if (checkStepIsCompletedVendor(url, this.globle.cApp.statusModel)) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + url;
        this.router.navigate([navigate]);
      }

      this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
      if (url == this.subUrl) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + this.subUrl;
        this.router.navigate([navigate]);
      }
    }
  }

  GetProgressStepDetailsById(priceQuoteId: number) {
    this.PricingQuotesMaster.GetProgressStepDetailsById(this.tokenKey, this.priceQuoteId).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.globle.cApp.statusModel = result['progress'];
          this.subUrl = getIncompletedStepVendor(this.globle.cApp.statusModel);
          this.activeTab('client-notes', 13);
        }
      });
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  GetComplianceByClientInformationId(priceQuoteId) {
    this.blockDocument();
    this.PricingQuotesMaster.GetProposelByClientInformationId(this.tokenKey, priceQuoteId).subscribe(
      data => {
        if (data['status'] = 'Success') {
          this.unblockDocument();

          if (data['miscelleneous'] != null && data['miscelleneous'].length > 0) {
          }
        }
        else {
          this.unblockDocument();
        }
      }, error => { }
    );
  }

  GetMarketEntryDataById(priceQuoteId: number) {
    this.blockDocument();
    this.PricingQuotesMaster.GetMultipleMarketEntryData(this.tokenKey, priceQuoteId).subscribe(
      result => {
        this.unblockDocument();
        if (result['status'] == 'Success') {
          this.listofMarketEntryData = result['compliance'];

          if (this.listofMarketEntryData.length > 0) {
            this.isMarketEntry = true;
            this.buildMarketEntrySections();
          } else {
            this.isMarketEntry = false;
            this.marketEntrySections = [];
          }
        }
      });
  }

  private getProviderLabel(providerId: number): string {
    if (MARKET_ENTRY_PROVIDER_LABELS[providerId]) {
      return MARKET_ENTRY_PROVIDER_LABELS[providerId];
    }
    return 'Provider ' + providerId;
  }

  private createEmptySection(providerId: number, expanded: boolean): MarketEntrySection {
    return {
      providerId: providerId,
      provider: this.getProviderLabel(providerId),
      expanded: expanded,
      rows: [],
      sosServiceFees: 0,
      sosCorpFeelingFees: 0,
      sosLLCFeelingFees: 0,
      registeredAgentFees: 0,
      pucServiceFees: 0,
      pscFeelingFees: 0,
      localCounselFees: 0,
      inteserraTotal: 0,
      dbaFillinfFees: 0,
      dbaServiceFees: 0,
      dbA_RA_Fees: 0,
      bond: 0,
      puC_Filing_Fees: 0,
      soS_Service_Fees_SelectedAll: false,
      dbA_Service_Fees_SelectedAll: false,
      soS_Corp_Filling_Fees_SelectedAll: false,
      soS_LLC_Filing_Fees_SelectedAll: false,
      dbA_Filing_Fees_SelectedAll: false,
      registered_Agent_Fees_SelectedAll: false,
      puC_Service_Fees_SelectedAll: false,
      puC_Filing_Fees_SelectedAll: false,
      psC_FilingsAndPublication_Fees_SelectedAll: false,
      local_Counsel_Fees_SelectedAll: false,
      registered_Agent_DBA_Fees_SelectedAll: false,
      bond_SelectedAll: false,
      soS_Service_Fees_NAisSelected: false,
      dbA_Service_Fees_NAisSelected: false,
      soS_Corp_Filling_Fees_NAisSelected: false,
      soS_LLC_Filing_Fees_NAisSelected: false,
      dbA_Filing_Fees_NAisSelected: false,
      registered_Agent_Fees_NAisSelected: false,
      puC_Service_Fees_NAisSelected: false,
      psC_FilingsAndPublication_Fees_NAisSelected: false,
      local_Counsel_Fees_NAisSelected: false,
      registered_Agent_DBA_Fees_NAisSelected: false,
      bond_NAisSelected: false,
      puC_Filing_Fees_NAisSelected: false
    };
  }

  private getSectionEligibleRows(section: MarketEntrySection): MarketEntryDataModel[] {
    return section.rows.filter(function (x) {
      return x.stateName != 'Puerto Rico' && x.stateName != 'Canada';
    });
  }

  buildMarketEntrySections() {
    const providerIds: number[] = [];
    const sectionsMap: { [key: number]: MarketEntrySection } = {};

    for (let i = 0; i < this.listofMarketEntryData.length; i++) {
      const row = this.listofMarketEntryData[i];
      const providerId = row.marketEntryType != null ? row.marketEntryType : this.marketEntryProvider;
      if (providerIds.indexOf(providerId) === -1) {
        providerIds.push(providerId);
      }
      if (!sectionsMap[providerId]) {
        sectionsMap[providerId] = this.createEmptySection(providerId, providerIds.length === 1);
      }
      sectionsMap[providerId].rows.push(row);
    }

    providerIds.sort(function (a, b) { return a - b; });

    this.marketEntrySections = [];
    for (let i = 0; i < providerIds.length; i++) {
      const section = sectionsMap[providerIds[i]];
      section.expanded = i === 0;
      this.recalculateSection(section);
      this.marketEntrySections.push(section);
    }

    this.recalculateGlobalTotals();
  }

  private recalculateSection(section: MarketEntrySection) {
    const eligibleRows = this.getSectionEligibleRows(section);
    const totalEligibleRows = eligibleRows.length;

    section.sosServiceFees = 0;
    section.sosCorpFeelingFees = 0;
    section.pucServiceFees = 0;
    section.pscFeelingFees = 0;
    section.registeredAgentFees = 0;
    section.localCounselFees = 0;
    section.dbaFillinfFees = 0;
    section.dbaServiceFees = 0;
    section.sosLLCFeelingFees = 0;
    section.dbA_RA_Fees = 0;
    section.bond = 0;
    section.puC_Filing_Fees = 0;

    section.soS_Service_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.soS_Service_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.dbA_Service_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.dbA_Service_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.soS_Corp_Filling_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.soS_Corp_Filling_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.soS_LLC_Filing_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.soS_LLC_Filing_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.dbA_Filing_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.dbA_Filing_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.registered_Agent_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.registered_Agent_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.puC_Service_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.puC_Service_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.psC_FilingsAndPublication_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.psC_FilingsAndPublication_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.local_Counsel_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.local_Counsel_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.registered_Agent_DBA_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.dbA_RA_Fees_isSelected == true;
    }).length === totalEligibleRows;

    section.puC_Filing_Fees_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
      return x.puC_Filing_Fees_isSelected == true;
    }).length === totalEligibleRows;

    if (section.providerId != 4) {
      section.bond_SelectedAll = totalEligibleRows > 0 && eligibleRows.filter(function (x) {
        return x.bond_isSelected == true;
      }).length === totalEligibleRows;
    } else {
      section.bond_SelectedAll = false;
    }

    section.soS_Service_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.soS_Service_Fees_NAisSelected == true;
    }).length > 0;

    section.dbA_Service_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.dbA_Service_Fees_NAisSelected == true;
    }).length > 0;

    section.soS_Corp_Filling_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.soS_Corp_Filling_Fees_NAisSelected == true;
    }).length > 0;

    section.soS_LLC_Filing_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.soS_LLC_Filing_Fees_NAisSelected == true;
    }).length > 0;

    section.dbA_Filing_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.dbA_Filing_Fees_NAisSelected == true;
    }).length > 0;

    section.registered_Agent_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.registered_Agent_Fees_NAisSelected == true;
    }).length > 0;

    section.puC_Service_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.puC_Service_Fees_NAisSelected == true;
    }).length > 0;

    section.psC_FilingsAndPublication_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.psC_FilingsAndPublication_Fees_NAisSelected == true;
    }).length > 0;

    section.local_Counsel_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.local_Counsel_Fees_NAisSelected == true;
    }).length > 0;

    section.registered_Agent_DBA_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.dbA_RA_Fees_NAisSelected == true;
    }).length > 0;

    section.puC_Filing_Fees_NAisSelected = section.rows.filter(function (x) {
      return x.puC_Filing_Fees_NAisSelected == true;
    }).length > 0;

    if (section.providerId != 4) {
      section.bond_NAisSelected = section.rows.filter(function (x) {
        return x.bond_NAisSelected == true;
      }).length > 0;
    } else {
      section.bond_NAisSelected = false;
    }

    for (let iCounter = 0; iCounter < section.rows.length; iCounter++) {
      const row = section.rows[iCounter];
      let rowTotal = 0.00;

      if (row.soS_Service_Fees_isSelected && !section.soS_Service_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.soS_Service_Fees;
      if (row.dbA_Service_Fees_isSelected && !section.dbA_Service_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.dbA_Service_Fees;
      if (row.soS_Corp_Filling_Fees_isSelected && !section.soS_Corp_Filling_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.soS_Corp_Filling_Fees;
      if (row.dbA_Filing_Fees_isSelected && !section.dbA_Filing_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.dbA_Filing_Fees;
      if (row.soS_LLC_Filing_Fees_isSelected && !section.soS_LLC_Filing_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.soS_LLC_Filing_Fees;
      if (row.registered_Agent_Fees_isSelected && !section.registered_Agent_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.registered_Agent_Fees;
      if (row.local_Counsel_Fees_isSelected && !section.local_Counsel_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.local_Counsel_Fees;
      if (row.puC_Service_Fees_isSelected && !section.puC_Service_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.puC_Service_Fees;
      if (row.psC_FilingsAndPublication_Fees_isSelected && !section.psC_FilingsAndPublication_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.psC_FilingsAndPublication_Fees;
      if (row.dbA_RA_Fees_isSelected && !section.registered_Agent_DBA_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.dbA_RA_Fees;
      if (row.puC_Filing_Fees_isSelected && !section.puC_Filing_Fees_NAisSelected)
        rowTotal = +rowTotal + +row.puC_Filing_Fees;
      if (section.providerId != 4 && row.bond_isSelected && !section.bond_NAisSelected)
        rowTotal = +rowTotal + +row.bond;

      row.total = +rowTotal;

      if (row.soS_Service_Fees_isSelected && !section.soS_Service_Fees_NAisSelected)
        section.sosServiceFees = section.sosServiceFees + +row.soS_Service_Fees;
      if (row.dbA_Filing_Fees_isSelected && !section.dbA_Filing_Fees_NAisSelected)
        section.dbaFillinfFees = section.dbaFillinfFees + +row.dbA_Filing_Fees;
      if (row.dbA_Service_Fees_isSelected && !section.dbA_Service_Fees_NAisSelected)
        section.dbaServiceFees = section.dbaServiceFees + +row.dbA_Service_Fees;
      if (row.soS_Corp_Filling_Fees_isSelected && !section.soS_Corp_Filling_Fees_NAisSelected)
        section.sosCorpFeelingFees = section.sosCorpFeelingFees + +row.soS_Corp_Filling_Fees;
      if (row.puC_Service_Fees_isSelected && !section.puC_Service_Fees_NAisSelected)
        section.pucServiceFees = section.pucServiceFees + +row.puC_Service_Fees;
      if (row.psC_FilingsAndPublication_Fees_isSelected && !section.psC_FilingsAndPublication_Fees_NAisSelected)
        section.pscFeelingFees = section.pscFeelingFees + +row.psC_FilingsAndPublication_Fees;
      if (row.registered_Agent_Fees_isSelected && !section.registered_Agent_Fees_NAisSelected)
        section.registeredAgentFees = section.registeredAgentFees + +row.registered_Agent_Fees;
      if (row.local_Counsel_Fees_isSelected && !section.local_Counsel_Fees_NAisSelected)
        section.localCounselFees = section.localCounselFees + +row.local_Counsel_Fees;
      if (row.soS_LLC_Filing_Fees_isSelected && !section.soS_LLC_Filing_Fees_NAisSelected)
        section.sosLLCFeelingFees = section.sosLLCFeelingFees + +row.soS_LLC_Filing_Fees;
      if (row.dbA_RA_Fees_isSelected && !section.registered_Agent_DBA_Fees_NAisSelected)
        section.dbA_RA_Fees = section.dbA_RA_Fees + +row.dbA_RA_Fees;
      if (row.puC_Filing_Fees_isSelected && !section.puC_Filing_Fees_NAisSelected)
        section.puC_Filing_Fees = section.puC_Filing_Fees + +row.puC_Filing_Fees;
      if (section.providerId != 4 && row.bond_isSelected && !section.bond_NAisSelected)
        section.bond = section.bond + +row.bond;
    }

    section.inteserraTotal = section.sosServiceFees + section.dbaServiceFees + section.sosCorpFeelingFees +
      section.sosLLCFeelingFees + section.dbaFillinfFees + section.registeredAgentFees + section.pucServiceFees +
      section.pscFeelingFees + section.localCounselFees + section.dbA_RA_Fees + section.bond + section.puC_Filing_Fees;
  }

  private recalculateGlobalTotals() {
    this.sosServiceFees = 0;
    this.sosCorpFeelingFees = 0;
    this.pucServiceFees = 0;
    this.pscFeelingFees = 0;
    this.registeredAgentFees = 0;
    this.localCounselFees = 0;
    this.dbaFillinfFees = 0;
    this.dbaServiceFees = 0;
    this.sosLLCFeelingFees = 0;
    this.dbA_RA_Fees = 0;
    this.bond = 0;
    this.puC_Filing_Fees = 0;

    for (let i = 0; i < this.marketEntrySections.length; i++) {
      const section = this.marketEntrySections[i];
      this.sosServiceFees += section.sosServiceFees;
      this.sosCorpFeelingFees += section.sosCorpFeelingFees;
      this.pucServiceFees += section.pucServiceFees;
      this.pscFeelingFees += section.pscFeelingFees;
      this.registeredAgentFees += section.registeredAgentFees;
      this.localCounselFees += section.localCounselFees;
      this.dbaFillinfFees += section.dbaFillinfFees;
      this.dbaServiceFees += section.dbaServiceFees;
      this.sosLLCFeelingFees += section.sosLLCFeelingFees;
      this.dbA_RA_Fees += section.dbA_RA_Fees;
      this.bond += section.bond;
      this.puC_Filing_Fees += section.puC_Filing_Fees;
    }

    this.dbaComSpecFillingFees = this.dbaFillinfFees * 2;
    this.dbaComSpecServiceFees = this.dbaServiceFees * 2;
    this.inteserraTotal = this.sosServiceFees + this.dbaServiceFees + this.sosCorpFeelingFees + this.sosLLCFeelingFees +
      this.dbaFillinfFees + this.registeredAgentFees + this.pucServiceFees + this.pscFeelingFees + this.localCounselFees +
      this.dbA_RA_Fees + this.bond + this.puC_Filing_Fees;
    this.previousTotal = this.inteserraTotal;
    this.companyTotal = this.registeredAgentFees + this.localCounselFees + this.dbaComSpecFillingFees;
  }

  private applySectionNaFlagsToRows(section: MarketEntrySection) {
    for (let i = 0; i < section.rows.length; i++) {
      const row = section.rows[i];
      row.soS_Service_Fees_NAisSelected = section.soS_Service_Fees_NAisSelected;
      row.dbA_Service_Fees_NAisSelected = section.dbA_Service_Fees_NAisSelected;
      row.soS_Corp_Filling_Fees_NAisSelected = section.soS_Corp_Filling_Fees_NAisSelected;
      row.soS_LLC_Filing_Fees_NAisSelected = section.soS_LLC_Filing_Fees_NAisSelected;
      row.dbA_Filing_Fees_NAisSelected = section.dbA_Filing_Fees_NAisSelected;
      row.registered_Agent_Fees_NAisSelected = section.registered_Agent_Fees_NAisSelected;
      row.puC_Service_Fees_NAisSelected = section.puC_Service_Fees_NAisSelected;
      row.psC_FilingsAndPublication_Fees_NAisSelected = section.psC_FilingsAndPublication_Fees_NAisSelected;
      row.local_Counsel_Fees_NAisSelected = section.local_Counsel_Fees_NAisSelected;
      row.dbA_RA_Fees_NAisSelected = section.registered_Agent_DBA_Fees_NAisSelected;
      row.bond_NAisSelected = section.bond_NAisSelected;
      row.puC_Filing_Fees_NAisSelected = section.puC_Filing_Fees_NAisSelected;
    }
  }

  SelectedEntryCheck(detail, section: MarketEntrySection) {
    this.recalculateSection(section);
    this.recalculateGlobalTotals();
  }

  selectedState_soS_Service_Fees(value, columnName, section: MarketEntrySection) {
    for (let iCounter = 0; iCounter < section.rows.length; iCounter++) {
      if (section.rows[iCounter].stateName != 'Canada') {
        if (columnName == 'SOS_Service_Fees')
          section.rows[iCounter].soS_Service_Fees_isSelected = value;
        if (columnName == 'DBA_Service_Fees')
          section.rows[iCounter].dbA_Service_Fees_isSelected = value;
        if (columnName == 'SOS_Corp_Fees')
          section.rows[iCounter].soS_Corp_Filling_Fees_isSelected = value;
        if (columnName == 'SOS_LLC_Fees')
          section.rows[iCounter].soS_LLC_Filing_Fees_isSelected = value;
        if (columnName == 'DBA_Filing_Fees')
          section.rows[iCounter].dbA_Filing_Fees_isSelected = value;
        if (columnName == 'Registered_Agent_Fees')
          section.rows[iCounter].registered_Agent_Fees_isSelected = value;
        if (columnName == 'PUC_Service_Fees')
          section.rows[iCounter].puC_Service_Fees_isSelected = value;
        if (columnName == 'PSC_FilingsAndPublication_Fees')
          section.rows[iCounter].psC_FilingsAndPublication_Fees_isSelected = value;
        if (columnName == 'Local_Counsel_Fees')
          section.rows[iCounter].local_Counsel_Fees_isSelected = value;
        if (columnName == 'bond')
          section.rows[iCounter].bond_isSelected = value;
        if (columnName == 'Registered_Agent_DBA_Fees')
          section.rows[iCounter].dbA_RA_Fees_isSelected = value;
        if (columnName == 'PUC_Filing_Fees')
          section.rows[iCounter].puC_Filing_Fees_isSelected = value;
      }
    }
    this.recalculateSection(section);
    this.recalculateGlobalTotals();
  }

  selectedState_NA_Fees(value, columnName, section: MarketEntrySection) {
    if (columnName == 'SOS_Service_Fees')
      section.soS_Service_Fees_NAisSelected = value;
    if (columnName == 'DBA_Service_Fees')
      section.dbA_Service_Fees_NAisSelected = value;
    if (columnName == 'SOS_Corp_Fees')
      section.soS_Corp_Filling_Fees_NAisSelected = value;
    if (columnName == 'SOS_LLC_Fees')
      section.soS_LLC_Filing_Fees_NAisSelected = value;
    if (columnName == 'DBA_Filing_Fees')
      section.dbA_Filing_Fees_NAisSelected = value;
    if (columnName == 'Registered_Agent_Fees')
      section.registered_Agent_Fees_NAisSelected = value;
    if (columnName == 'PUC_Service_Fees')
      section.puC_Service_Fees_NAisSelected = value;
    if (columnName == 'PSC_FilingsAndPublication_Fees')
      section.psC_FilingsAndPublication_Fees_NAisSelected = value;
    if (columnName == 'Local_Counsel_Fees')
      section.local_Counsel_Fees_NAisSelected = value;
    if (columnName == 'bond')
      section.bond_NAisSelected = value;
    if (columnName == 'Registered_Agent_DBA_Fees')
      section.registered_Agent_DBA_Fees_NAisSelected = value;
    if (columnName == 'PUC_Filing_Fees')
      section.puC_Filing_Fees_NAisSelected = value;

    this.applySectionNaFlagsToRows(section);
    this.recalculateSection(section);
    this.recalculateGlobalTotals();
  }

  changevalue(event: any, item, fieldName: string, section: MarketEntrySection) {
    const matchedRows = section.rows.filter(function (x) {
      return x.marketEntryId == item.marketEntryId && x.stateId == item.stateId;
    });

    if (matchedRows.length > 0) {
      const targetRow = matchedRows[0];
      if (fieldName == 'soS_Service_Fees')
        targetRow.soS_Service_Fees = +event;
      else if (fieldName == 'dbA_Service_Fees')
        targetRow.dbA_Service_Fees = +event;
      else if (fieldName == 'soS_Corp_Filling_Fees')
        targetRow.soS_Corp_Filling_Fees = +event;
      else if (fieldName == 'soS_LLC_Filing_Fees')
        targetRow.soS_LLC_Filing_Fees = +event;
      else if (fieldName == 'dbA_Filing_Fees')
        targetRow.dbA_Filing_Fees = +event;
      else if (fieldName == 'registered_Agent_Fees')
        targetRow.registered_Agent_Fees = +event;
      else if (fieldName == 'puC_Service_Fees')
        targetRow.puC_Service_Fees = +event;
      else if (fieldName == 'psC_FilingsAndPublication_Fees')
        targetRow.psC_FilingsAndPublication_Fees = +event;
      else if (fieldName == 'local_Counsel_Fees')
        targetRow.local_Counsel_Fees = +event;
      else if (fieldName == 'registered_Agent_DBA_Fees')
        targetRow.dbA_RA_Fees = +event;
      else if (fieldName == 'bond')
        targetRow.bond = +event;
      else if (fieldName == 'puC_Filing_Fees')
        targetRow.puC_Filing_Fees = +event;
      else if (fieldName == 'Notes')
        targetRow.notes = event;

      this.recalculateSection(section);
      this.recalculateGlobalTotals();
    }
  }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }
}
